import { useState, useContext } from 'react';
import { NavLink, Link } from 'react-router-dom';
import { AssignmentTurnedIn, Menu, Close, LocalShippingOutlined, AccountCircle, Logout } from '@mui/icons-material';
import { twMerge } from 'tailwind-merge';
import logo from '../../assets/freight-roll-logo.png';
import { UserContext } from '../../App';
import { logoutWithApi } from '../../services/authService';

const AndroidTopBar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const userContext = useContext(UserContext);
  // @ts-ignore
  const { user } = userContext;

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  const handleLogout = async () => {
    await logoutWithApi();
    window.location.href = '/login';
  };

  return (
    <>
      {/* Top Bar */}
      <div className="fixed top-0 left-0 right-0 z-30 bg-[#323D48] text-white shadow-lg">
        <div className="flex items-center justify-between px-4 py-3">
          {/* Hamburger Button */}
          <button
            onClick={toggleMenu}
            className="p-2 rounded-lg hover:bg-[#222A33] transition-colors"
            aria-label="Toggle menu"
          >
            {isMenuOpen ? <Close className="!h-6 !w-6" /> : <Menu className="!h-6 !w-6" />}
          </button>

          {/* Logo/Title */}
          <div className="flex items-center">
            <img src={logo} alt="FreightRoll Logo" className="h-8" />
          </div>

          {/* User Avatar - clickable to go to account page */}
          <Link
            to="/account"
            className="w-10 flex justify-center p-2 rounded-lg hover:bg-[#222A33] transition-colors"
            aria-label="Go to account page"
          >
            <AccountCircle className="!h-6 !w-6 text-gray-300 hover:text-white transition-colors" />
          </Link>
        </div>
      </div>

      {/* Content spacer to account for fixed top bar */}
      <div className="h-16"></div>

      {/* Overlay */}
      {isMenuOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-40"
          onClick={toggleMenu}
        />
      )}

      {/* Menu Panel */}
      <div
        className={twMerge(
          'fixed left-0 right-0 bg-[#323D48] text-white transform transition-transform duration-300 ease-in-out z-50 shadow-lg',
          isMenuOpen ? 'top-16 translate-y-0' : 'top-0 -translate-y-full'
        )}
      >
        <div className="px-6 py-6">
          {/* Navigation Section with User Info */}
          <div className="flex items-center justify-between mb-4">
            <h2 className="text-[#979ba7] text-lg font-medium">Yard Management</h2>
            <div className="flex items-center space-x-4">
              <div className="flex items-center">
                <AccountCircle className="mr-2 !h-5 !w-5 text-gray-300" />
                <Link
                  to="/account"
                  className="text-[#2dc3e8] hover:text-[#fb6e52] text-sm"
                  onClick={toggleMenu}
                >
                  {user?.email}
                </Link>
              </div>
              <button
                onClick={handleLogout}
                className="flex items-center px-2 py-1 text-red-400 hover:text-red-300 hover:bg-[#222A33] rounded text-sm transition-colors"
              >
                <Logout className="mr-1 !h-4 !w-4" />
                Logout
              </button>
            </div>
          </div>
          
          <NavLink
            to="/taskapp"
            className={({ isActive }) =>
              twMerge(
                'px-5 py-4 hover:bg-[#222A33] border-[#2dc3e8] border-l-4 hover:border-[#fb6e52] flex items-center rounded-r-lg text-base inline-block',
                isActive ? 'bg-[#222A33] border-[#fb6e52]' : ''
              )
            }
            onClick={toggleMenu}
          >
            <AssignmentTurnedIn className="mr-3 !h-6 !w-6" />
            Tasks
          </NavLink>
          <NavLink
            to="/trailers"
            className={({ isActive }) =>
              twMerge(
                'px-5 py-4 hover:bg-[#222A33] border-[#2dc3e8] border-l-4 hover:border-[#fb6e52] flex items-center rounded-r-lg text-base inline-block',
                isActive ? 'bg-[#222A33] border-[#fb6e52]' : ''
              )
            }
            onClick={toggleMenu}
          >
            <LocalShippingOutlined className="mr-3 !h-6 !w-6" />
            Trailers
          </NavLink>

          <NavLink
            to="/yard/spotter"
            className={({ isActive }) =>
              twMerge(
                'px-5 py-4 hover:bg-[#222A33] border-[#2dc3e8] border-l-4 hover:border-[#fb6e52] flex items-center rounded-r-lg text-base inline-block',
                isActive ? 'bg-[#222A33] border-[#fb6e52]' : ''
              )
            }
            onClick={toggleMenu}
          >
            Yard Check
          </NavLink>

          <NavLink
            to="/dock"
            className={({ isActive }) =>
              twMerge(
                'px-5 py-4 hover:bg-[#222A33] border-[#2dc3e8] border-l-4 hover:border-[#fb6e52] flex items-center rounded-r-lg text-base inline-block',
                isActive ? 'bg-[#222A33] border-[#fb6e52]' : ''
              )
            }
            onClick={toggleMenu}
          >
            Dock Management
          </NavLink>
        </div>
      </div>
    </>
  );
};

export default AndroidTopBar; 